import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { setCalcTab } from '../actions/actionCreators'
import { RF_TABS } from '../constants'
import { CalcType } from '../model/enums'
import { appSelector } from '../store/selectors'
import { TabLink, TabLinks } from './TabLinks'

interface IProps {
  children: ReactNode
}

const InputsContainer = ({ children }: IProps) => {
  const { calcType } = useSelector(appSelector)
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const handleChangeTab = (type: CalcType) => dispatch(setCalcTab(type))

  return (
    <div className='cs-md-8of12 csas-calc-left-section'>
      <div className='csas-calc-white-section'>
        <TabLinks>
          <TabLink
            label={t('CALC_TABS.AMOUNT')}
            isActive={calcType === CalcType.Amount}
            value={CalcType.Amount}
            rf={RF_TABS.AMOUNT}
            onClick={handleChangeTab}
          />
          <TabLink
            label={t('CALC_TABS.SAVINGS')}
            isActive={calcType === CalcType.Savings}
            value={CalcType.Savings}
            rf={RF_TABS.SAVINGS}
            onClick={handleChangeTab}
          />
        </TabLinks>
        {children}
      </div>
    </div>
  )
}

export default InputsContainer
